"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasTransferOrderLines = void 0;
const hasTransferOrderLines = (order) => {
    if (!order)
        return false;
    if (!order.order_lines)
        return false;
    // loop through each order line and check if all versions are confirmed
    let has_transfer = false;
    order.order_lines.forEach((line) => {
        if (line.type === "TRANSFER")
            has_transfer = true;
    });
    return has_transfer;
};
exports.hasTransferOrderLines = hasTransferOrderLines;
